import { useParams } from "react-router-dom";
import { StateInfoList } from "./StateInfoList";

/** Shows the starting parameters in `Dtg`. Those are set in the URL. */
export function DtgStateInfo(): JSX.Element {
  const { variant, stimuli, durations, seconds } = useParams();

  return (
    <StateInfoList
      rows={[
        ["variant", variant],
        ["stimuli", stimuli, "100;100;100"],
        ["durations", durations, "1100;1000;800"],
        ["seconds", seconds, "150;150"],
      ]}
    />
  );
}
